<template>
    <v-container fluid style="position: absolute; top: 5%; pointer-events: none; z-index:700; text-align:center">
        <v-flex d-inline-flex class="shrink">
            <v-alert
            :type="statusType"
            :value="isVisible"
            dismissible
            transition="scale-transition"
            tag="div"
            class="mx-auto my-2 text-center rounded-xl"
            style="pointer-events: all; z-index:70"
            >{{ message }}</v-alert>
        </v-flex>
    </v-container>
</template>


<script>
    import {mapState} from 'vuex'

    export default {
        computed: mapState({
            statusType: state => state.util.StatusSnackBar.statusType,
            message: state => state.util.StatusSnackBar.message,
            isVisible: state => state.util.StatusSnackBar.isVisible,
        })
    }
</script>

<style scoped>
.v-alert {
    backdrop-filter: blur(18px) saturate(160%) !important;
    -webkit-backdrop-filter: blur(18px) saturate(160%) !important;
    border-radius: 14px !important;
}

/* ── Light mode — more transparent ── */
.theme--light .v-alert.error   { background: rgba(255, 61,  61,  0.90) !important; }
.theme--light .v-alert.warning { background: rgba(251, 140,  0,  0.90) !important; }
.theme--light .v-alert.success { background: rgba(30,  200, 130, 0.90) !important; }
.theme--light .v-alert.info    { background: rgba(33,  150, 243, 0.90) !important; }

/* ── Dark mode — more opaque ── */
.theme--dark .v-alert.error   { background: rgba(255, 61,  61,  0.55) !important; }
.theme--dark .v-alert.warning { background: rgba(251, 140,  0,  0.55) !important; }
.theme--dark .v-alert.success { background: rgba(30,  200, 130, 0.55) !important; }
.theme--dark .v-alert.info    { background: rgba(33,  150, 243, 0.55) !important; }

/* Dark mode border — subtler white highlight */
.theme--dark .v-alert {
    border-color: rgba(255, 255, 255, 0.15) !important;
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.35),
        0 2px 8px rgba(0, 0, 0, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
}
</style>